export default {
  getTermCondition: state =>  {
    return state.TermCondition
  },
}